/*eslint-disable*/
//disable debug
 // console.log = function() {}
 // console.info = function() {}

window.dynamicLists = initDynamicListsModule();

/////////////////////////// VARIABLES ////////////////////////////
// predefined lists that do not change
var imageFormats = [".jpg", ".jpeg", ".png", ".gif", ".bmp", ".pdf"];
var audioFormats = [".mp3"];
var videoFormats = [".mp4"];
var imageAudioVideoFormats = [imageFormats, audioFormats, videoFormats];
var imageAudioVideoFormatsCapsIncluded = [imageAudioVideoFormats, String(imageAudioVideoFormats).toUpperCase().split(",")];
//flatten arrays
imageAudioVideoFormats = [].concat.apply([], imageAudioVideoFormats);
imageAudioVideoFormatsCapsIncluded = [].concat.apply([], imageAudioVideoFormatsCapsIncluded);
var stimFormats = [imageFormats, audioFormats, videoFormats, "word", "survey", "form"];
// var allColumns = ["..."];
var maxStimOnScreen = 6;
var locationStim = window.stimuliBaseUrl + document.location.pathname.split('/').slice(0, -1).join('/') + '/' + stimuliVersion + "/stimuli/";
var locationConsent = "consent/";

var progressBar = 0;

// //////////////// IGNORE -- PROJECT CLASS - includes all properties related to a project ////////////////////////////////
// var Project = function() {
//   this.bgColor;
//   this.textColor;
//   this.textSize;
//   this.status;
//   this.name;
//   this.created;
//   this.modified;
//   this.expiry;
//   this.pwdProtected;
//   this.pwd;
//   this.canvasWidth;
//   this.canvasHeight;
//   this.definedColumns; //see below how to determine this
// };
// // can I add here the spreadsheet? something like: this.trialFile.columnName1; this.trialFile.columnName2, etc.
// // where columnName1=trialFileColumns[0], etc.
// // what's the most efficient way to do this?

// /////////////// CREATE INSTANCES ////////////////////////
// var thisProject = new Project();
// // how best to transfer all values from database or setup.xml to this project instance?
//
///////////// TRIAL CLASS //////////////////
// var Trial = function() {

// };
// /////////// RESULTS CLASS - do I need it separately from TRIAL CLASS? ///////////////
// var Results = function() {

// };

///////////// IMAGE CLASS - IGNORE FOR NOW //////////////////
// var ImageObject = function(htmlContainer) {
//   this.container = htmlContainer;
//   this.source; //get from spreadsheet
//   this.extension; //get from spreadsheet
//   this.width; //determine after preloading
//   this.height; //determine after preloading
//   this.clickable; //compute from spreadsheet
//   this.top; //compute from spreadsheet and other stim
//   this.left; //compute from spreadsheet and other stim
//   this.display = "none";
// };

// var image = {};

// for (i = 0; i < 6; i++) {
//   image[i] = new ImageObject("image" + i);
//   // console.log(image[i].container);
// }

// // console.log(image);

// var WordObject = function() {
//   this.div;
//   this.source; //get from spreadsheet
//   this.width; //default; change if certain conditions
//   this.height; //default; change if certain conditions
//   this.clickable; //compute from spreadsheet
//   this.top; //compute from spreadsheet and other stim
//   this.left; //compute from spreadsheet and other stim
//   this.visible;
// };

// var AudioObject = function() {
//   this.div;
//   this.source; //get from spreadsheet
//   this.width; //default
//   this.height; //default
//   this.top; //default
//   this.left; //default
//   this.visible;
// };

// var VideoObject = function() {
//   this.div;
//   this.source; //get from spreadsheet
//   this.width; //determine after preloading (possible? if not, right before playing)
//   this.height; //determine after preloading (possible? if not, right before playing)
//   this.top; //compute from spreadsheet and current width/height
//   this.left; //compute from spreadsheet and current width/height
//   this.visible;
// };
///////////////// STOP IGNORE //////////////////////////////
////////////// END IGNORE ///////////////////////////


// All displayed survey/questions (form type trial rows) data
// used for validation and saving batched rows
var displayedFormData = [];
var mainSurveyButton; // survey button
var inputsPosition = 0; // current position of input to display
var inputsPositionSaveData = 0; // current position of input to sav
var formInfo = {};
//////////// END FORM VARIABLES //////////////////

var bgColor_default = "#808080";//grey
var textColor_default = "black";
var textSize_default = 16;

var bgColor_form = "#F3F3F4";//light grey
var textColor_form = "#676a6c";

//this should be removed when moved to testable.org; will get them from the setup.xml file
var projectName;
var language;
var expirationDate;
var created_at;
var updated_at;
var pwdProtected;
var pwd;
var canvasWidth;
var canvasHeight;
var newDisplayScreenWidth;var newDisplayScreenHeight;var newDisplayScreenMargin;var newDisplayScreenFontSize;
var touchscreen;
var bgColor_setup;
var textColor_setup;
var textBgColor_setup;
var textSize_setup;
var screen_pdetails = "";
var participant_min_age;
var participant_max_age;
var allow_under_18;
var screen_fullscreen = false;
var advanced_random = false;
var enable_email_catching = true;
var screen_calibrate = "on";
var screen_general = "on";
var screen_infosheet = "on";
var screen_consent = "";
var record_os;
var record_browser;
var record_screen_size;
var record_audio_all;
var record_framerate;
var generate_code;
var display_score;
var save_on_server = "on";//will get overwritten (hopefully) but Setup under testable.org
var save_on_computer = "on";
var status;
var participant_feedback;
var show_debrief;
var show_visuals;
var participant_mandatory_fields;

var thisContainer = "";

var debrief_text;
var debrief_average_text;
var debrief_is_random_code;
var debrief_code;
var debrief_code_text;
var debrief_show_link;
var debrief_link_url;
var debrief_auto_redirect;
var debrief_link_text;
var debrief_link_textarea;

//for calibration

var current_direction = 0;
var interval = 0;
var adjuster = 1;
var feedbackScreen = 0;//indicator for feedback screen

var screenType, prevScreenType;//used for auxiliary screens (p_details, end, etc)



//declare variables needed; easy to track
var debug = 0;//not used for the moment, but maybe in the future
var results = [];
var resultsTransposed = [];
var rowNo = ['rowNo'];
var responses = ['response'];
var clickResponseValue = '';
var responseCodes = ['responseCode'];
var RTs = ['RT'];
var RTkeys = ["RTkeys"];
var RTkeys_trial = '';
// required for multiple key responses
window.keyPressedCounter = null;
window.trialKeysPressedCounter = 0;
window.keysTrial = null;
window.clickedImages = [];
// end required for multiple keys responses
var recordRTkeys = 0;
var timestamps = ["timestamp"];
var lastTs = 0;
var presTime_ms = ['presTime_ms'];
var presTime_f = ['presTime_f'];
var presTime_fDuration = ['presTime_fDuration'];
var presTime_actual_temp = [];
var stimPos_actual = ['stimPos_actual'];
var ITI_ms = ['ITI_ms'];
var ITI_f = ['ITI_f'];
var ITI_fDuration = ['ITI_fDuration'];
var realITI_temp;
var ISI_ms = ['ISI_ms'];
var ISI_f = ['ISI_f'];
var ISI_fDuration = ['ISI_fDuration'];
var realISI_temp = [];
var stimOrder_actual = ['stimOrder_actual'];
var stimOrderRandomized = [];
var startTime = performance.now();
var startTimestamp = (new Date()).getTime() - performance.now();
var correct = ["correct"];
var correctPractice = ["correctPractice"];
var correctSelect = ["correctSelect"];
var hasCorrectSelect = false;
var tallies = ['tallies'];
var scores = ['responseScore'];
var stimActual = ['stim_actual'];
var responseRowsActual = ['responseRows_actual'];
var actualValues = {};
var responseOptionsActual = ['responseOptions_actual'];
var responseTextValues = ['responseText'];
var currentResponseText = "na";

var allResponses = [];
var allResponseCodes = [];
var allRTs = [];
var allCorrects = [];


var timeout = [];
var timeoutPractice = [];

var randomCode;
var avgCorrect;
var avgCorrectSelect;

var rowResponses = [];
var rowResponseCodes = [];
var rowRTs = [];
var rowCorrects = [];

//computed on each scren, keeps the max top of all presented images on that screen
var minImagesTop = 0;
var minTrialAllImagesTop = 0;
var maxTrialAllImagesTop = 0;
var maxTrialAllImagesHeight = 0;
var stimuliPositions;

//store image containers names
stimContainers = new Array();
var maskContainer;
buttonsContainers = new Array();
var audioContainer;

var stimOrderTemp = new Array();
var stimOrderGroup = new Array();
var stimOrder = new Array();

var enableEnter = 0;
var enableClicks = new Array();
var listNoStim = new Array();
var listNoStimS2 = new Array();
var listTrialScreensTimings = new Array();
var listTrialTexts = new Array();
var listBackgroundOptions = [];
var listBackgroundSizes = [];
var listTrialFixation = new Array();
var listTrialResponseWindow = new Array();
var listTrialResponseOptions = new Array();
var listTrialBoxOptions = [];
var listTrialCssOptions = [];
var listTrialCursorOptions = [];
var listTrialColorOptions = [];
var labelBox = null;
var listTrialResponseRowsLabels = [];
var responseBoxesLabels = [];
var responseBoxes = [];
var listNoFormQ = new Array();
var listNoButtons = new Array();
var listStimType = new Array();
var listBlockNo = new Array();
var randomFlags = new Array();
var CFPTcorrectOrder = new Array();
var CFPTdisplayOrder = new Array();
var CFPTstartOrder = new Array();
var CFPTstartOrderItems = new Array();
var CFPTstartOrderStim = new Array();
var CFPTendOrder = new Array();
var CFPTendOrderItems = new Array();
var CFPTendOrderStim = new Array();
var CFPTerror = 0;
var timerDisplay; //need to exist when clearing some settimeout events not defined
var timerCFPTDisplay; //need to exist when clearing some settimeout events not defined
var tempISI;
var listTrialLongWords = [];
var listTrialFrames = [];
var listTrialBreak = [];
var breakQueueTime = [];
var breakQueueTrials = [];
var listTrialScripts = [];
var listTrialScores = [];
var elapsedTrials = 0;
var listStimSizeFunctions = [];
var lastPresPostponeIndex = 0;
var customVariables = {};
//define columns for forms
var maxFields = 10;
var formColumnsQ = new Array();
var formColumnsR = new Array();
for (var iQ = 0; iQ < maxFields; iQ++) {
  formColumnsQ[iQ] = 'formQ' + (iQ + 1);
  formColumnsR[iQ] = 'formR' + (iQ + 1);
}

// define columns for conditions
maxFields = 4;
var conditionColumns = new Array();
for (var iQ = 0; iQ < maxFields; iQ++)
{
  conditionColumns[iQ] = 'condition'+(iQ+1);
}

// define image and button columns
var imageColumns = new Array();
var sortColumns = new Array();
var buttonColumns = new Array();
imageColumns[0] = 'target';
for (var iQ = 0; iQ < window.stimFieldsMax; iQ++)
{
  imageColumns[iQ+1] = 'stim'+(iQ+1);
  sortColumns[iQ] = 'sort'+(iQ+1);
  buttonColumns[iQ] = 'button'+(iQ+1);
}
imageColumns.push('mask');

var images = new Array(imageColumns.length);
var consentImage;

// form/survey columns
var surveyColumns = [
  'code',
  'head',
  'body',
  'responseType',
  'responsePos',
  // 'responseChoices',
  // 'responseChoicesRandomize',
  'responseOptions',
  'responseOptionsRandom',
  'responseOther',
  'responseRows',
  // 'responseRowsRandomize',
  'responseRowsRandom',
  'required',
  'separator',
  'pageBreak',
  'pageName',
  'responseOrientation',
  'responseCodes'
];

var multiplayerColumns =  ['arena', 'arena_sequence', 'arena_advance', 'arena_responses'];
//these columns are not going to be present in results, so they shouldn't be imported in db either
var randomBlockPickColumns = ['block', 'rules'];

// put all columns together
var allColumns = ['test', 'subtest','type'].concat(
  conditionColumns,['trialNo'],
  'audio',
  imageColumns,sortColumns,[
  'randomStimOrder','randomStimPick','stimSize','stimPos','stimOptions',
  'key','presTime','presTimeS2','presTime2',
  'ITI','ISI',
  'fixation','fixationStim','stimFormat',
  'header','footer',
  'title','content','description','trialText','trialTextPos', 'trialTextOptions'
  ],
  buttonColumns,[
  'randomButtonPosition','inputBox','responseWindow',
  'leftArrow','rightArrow','topLeft','topRight',
  'feedback','feedbackCorrect','feedbackIncorrect','feedbackTime','feedbackOptions',
  'random','randomBlock','randomPick','trialGroup','counterPart',
  'subjectGroup',
  'counterTrial','counterBlock',
  'bgColor','textColor','textSize',
  'keyboard','responseOptions', 'responseWindow', 'waitStimEnd','order',
  'select','save','options',
  'timer','trigger','startTime',
  ],
  formColumnsQ,formColumnsR,
  surveyColumns,
  multiplayerColumns,
  'staircase',
  'if','then',
  'label',
  'break',
  'color',
  'stimList',
  'cursor',
  randomBlockPickColumns,
  'repeat',
  'background',
  'script',
  'score',
  'stim',
  'listOptions',
  'stim_actual'
  );
//create allColumns with lower cases only
var allColumnsLowerCase = allColumns.map(function(x){ return x.toLowerCase() })

var definedColumns = new Array(allColumns.length);
var positionColumns = new Array(allColumns.length);
var csvColumns = new Array();//length will be decided by actual columns in the csv spreadsheet
var csvValidColumns = new Array();//length will be decided by actual columns in the csv spreadsheet
var csvNewColumns = new Array();
var csvValidColumnsIndices = new Array();
var csvNewColumnsIndices = new Array();
// var csvStandardColumns = new Array(); //length will be decided by actual columns in the csv spreadsheet
// var csvNonStandardColumns = new Array(); //length will be decided by actual columns in the csv spreadsheet
var listArrays = new Array(allColumns.length);
var saveArrays = new Array(allColumns.length);
for (var iCol = 0; iCol < allColumns.length; iCol++)
{
  listArrays[iCol] = new Array();
  saveArrays[iCol] = new Array(allColumns[iCol]);
}

for (var iColImage = 0; iColImage < allColumns.length; iColImage++) {
  images[iColImage] = new Array();
}

// pre split the values from stimList column
window.stimListValues = [];

// var saveInfoColumns = ['id', 'age', 'sex', 'education', 'handedness', 'sexual orientation', 'ethnicity', 'nationality', 'other1', 'other2', 'other3', 'other4', 'other5', 'browser', 'version', 'screenWidth', 'screenHeight', 'OS', 'OS_lang', 'calibration', 'ip', 'completionCode'];
var saveInfoColumns = new Array();
var saveInfo = new Array(); //to store demographic details
var browserInfo = new Array();
var browser = new Array();

var nTestBlocks = 0;
var iTestBlock = 1;

var trial = -1;
var iBlock = 1;
var countRandomFlags = 0;
var recordKeys = 0;
var trialRow;
var testContainer;
var eventTimeOut;
var eventTimeOutMask;
var eventTimeOutS1;
var eventTimeOutS2;
var eventTimeOutLearn;
var eventTimeOutISI;
var eventTimeOutITI;
var eventTimeOutResponse;
var eventTimeOutFeedback;

var timeInMs;

var width, width1, width2, width3, width4, width5, width6, widthTarget;
var height, height1, height2, height3, heightTarget;
var widthText;
var heightText;
var widthImageContainer;
var heightImageContainer;
var widthWordContainer;
var widthTargetContainer;
var heightTargetContainer;

var firstHr = 1;//Added by Daniel; var needed for form - horizontal line
var counterSorts = 0;

var staircaseResults = {};
var inStaircaseGroupIndex = -1;

//testable custom events
var events = {
  stimClick: 'testable.stimClick',
  endTrial: 'testable.endTrial',
  doneExperimentSetup: 'testable.doneExperimentSetup',
  experimentCompleted: 'testable.experimentCompleted',
}

var trialsLogicFn = [];
var keyTrialsLogicFn = [];


///////////////////////// INITIAL FUNCTIONS ////////////////////////////

var url = window.location.href;
var stimFile = url.split('#');
var domain = (url.split('/'))[2];/*get domain name*/
var experimentName = (url.split('/'))[5];
var experimenterId = (url.split('/'))[4];

var stimFileXml = 'stimlists/trialfile.xml' + '?ts=' + Date.now();
var setupFile = 'setup.xml' + '?ts=' + Date.now();;
var stimFileCsv = 'files/trial_file.csv' + '?ts=' + Date.now();;

var xhr = new XMLHttpRequest();
xhr.open('GET', setupFile, false);
xhr.send();
xmlSetup = xhr.responseXML;

/*variables from setup.xml*/
try{projectName = xmlSetup.getElementsByTagName("PROJECT_NAME")[0].childNodes[0].nodeValue;} catch(err){projectName = "na";}
try{expirationDate = xmlSetup.getElementsByTagName("EXPIRATION_DATE")[0].childNodes[0].nodeValue;} catch(err){expirationDate = "na";}
try{language = xmlSetup.getElementsByTagName("LANGUAGE")[0].childNodes[0].nodeValue;} catch(err){language = "english";}
try{created_at = xmlSetup.getElementsByTagName("CREATED_AT")[0].childNodes[0].nodeValue;} catch(err){created_at = "na";}
try{updated_at = xmlSetup.getElementsByTagName("UPDATED_AT")[0].childNodes[0].nodeValue;} catch(err){updated_at = "na";}
try{pwdProtected = xmlSetup.getElementsByTagName("PASSWORD_PROTECTED")[0].childNodes[0].nodeValue;} catch(err){pwdProtected = "na";}
try{pwd = xmlSetup.getElementsByTagName("PASSWORD")[0].childNodes[0].nodeValue;} catch(err){pwd = "na";}
try{canvasWidth = xmlSetup.getElementsByTagName("WIDTH")[0].childNodes[0].nodeValue;} catch(err){canvasWidth = "na";}
try{canvasHeight = xmlSetup.getElementsByTagName("HEIGHT")[0].childNodes[0].nodeValue;} catch(err){canvasHeight = "na";}
try{touchscreen = xmlSetup.getElementsByTagName("TOUCHSCREEN")[0].childNodes[0].nodeValue;} catch(err){touchscreen = "na";}
try{bgColor_setup = xmlSetup.getElementsByTagName("BACKGROUND_COLOR")[0].childNodes[0].nodeValue;} catch(err){bgColor_setup = "na";}
try{screen_pdetails = xmlSetup.getElementsByTagName("PARTICIPANT_DETAILS")[0].childNodes[0].nodeValue;} catch(err){screen_pdetails = "na";}
try{participant_name = xmlSetup.getElementsByTagName("PARTICIPANT_NAME")[0].childNodes[0].nodeValue;} catch(err){participant_name = "na";}
try{participant_age = xmlSetup.getElementsByTagName("PARTICIPANT_AGE")[0].childNodes[0].nodeValue;} catch(err){participant_age = "na";}
try{participant_min_age = xmlSetup.getElementsByTagName("PARTICIPANT_MIN_AGE")[0].childNodes[0].nodeValue;} catch(err){participant_min_age = "na";}
try{participant_max_age = xmlSetup.getElementsByTagName("PARTICIPANT_MAX_AGE")[0].childNodes[0].nodeValue;} catch(err){participant_max_age = "na";}
try{allow_under_18 = xmlSetup.getElementsByTagName("ALLOW_UNDER_18")[0].childNodes[0].nodeValue;} catch(err){allow_under_18 = "na";}
try{participant_sex = xmlSetup.getElementsByTagName("PARTICIPANT_SEX")[0].childNodes[0].nodeValue;} catch(err){participant_sex = "na";}
try{participant_sex_assigned_at_birth = xmlSetup.getElementsByTagName("PARTICIPANT_SEX_ASSIGNED_AT_BIRTH")[0].childNodes[0].nodeValue;} catch(err){participant_sex_assigned_at_birth = "na";}
try{participant_education = xmlSetup.getElementsByTagName("PARTICIPANT_EDUCATION")[0].childNodes[0].nodeValue;} catch(err){participant_education = "na";}
try{participant_handedness = xmlSetup.getElementsByTagName("PARTICIPANT_HANDEDNESS")[0].childNodes[0].nodeValue;} catch(err){participant_handedness = "na";}
try{participant_sexual_orientation = xmlSetup.getElementsByTagName("PARTICIPANT_SEXUAL_ORIENTATION")[0].childNodes[0].nodeValue;} catch(err){participant_sexual_orientation = "na";}
try{participant_nationality = xmlSetup.getElementsByTagName("PARTICIPANT_NATIONALITY")[0].childNodes[0].nodeValue;} catch(err){participant_nationality = "na";}
try{participant_ethnicity = xmlSetup.getElementsByTagName("PARTICIPANT_ETHNICITY")[0].childNodes[0].nodeValue;} catch(err){participant_ethnicity = "na";}
try{participant_other1 = xmlSetup.getElementsByTagName("PARTICIPANT_OTHER1")[0].childNodes[0].nodeValue;} catch(err){participant_other1 = "na";}
try{participant_other2 = xmlSetup.getElementsByTagName("PARTICIPANT_OTHER2")[0].childNodes[0].nodeValue;} catch(err){participant_other2 = "na";}
try{participant_other3 = xmlSetup.getElementsByTagName("PARTICIPANT_OTHER3")[0].childNodes[0].nodeValue;} catch(err){participant_other3 = "na";}
try{participant_other4 = xmlSetup.getElementsByTagName("PARTICIPANT_OTHER4")[0].childNodes[0].nodeValue;} catch(err){participant_other4 = "na";}
try{participant_other5 = xmlSetup.getElementsByTagName("PARTICIPANT_OTHER5")[0].childNodes[0].nodeValue;} catch(err){participant_other5 = "na";}
try{participant_other1_label = xmlSetup.getElementsByTagName("PARTICIPANT_OTHER1_LABEL")[0].childNodes[0].nodeValue;} catch(err){participant_other1_label = "na";}
try{participant_other2_label = xmlSetup.getElementsByTagName("PARTICIPANT_OTHER2_LABEL")[0].childNodes[0].nodeValue;} catch(err){participant_other2_label = "na";}
try{participant_other3_label = xmlSetup.getElementsByTagName("PARTICIPANT_OTHER3_LABEL")[0].childNodes[0].nodeValue;} catch(err){participant_other3_label = "na";}
try{participant_other4_label = xmlSetup.getElementsByTagName("PARTICIPANT_OTHER4_LABEL")[0].childNodes[0].nodeValue;} catch(err){participant_other4_label = "na";}
try{participant_other5_label = xmlSetup.getElementsByTagName("PARTICIPANT_OTHER5_LABEL")[0].childNodes[0].nodeValue;} catch(err){participant_other5_label = "na";}
try{screen_fullscreen = xmlSetup.getElementsByTagName("REQUIRES_FULLSCREEN")[0].childNodes[0].nodeValue == "1"} catch(err){screen_fullscreen = false;}
try{advanced_random = xmlSetup.getElementsByTagName("ENABLE_TRUE_RANDOM")[0].childNodes[0].nodeValue == "1"} catch(err){advanced_random = false;}
try{enable_media_preload = xmlSetup.getElementsByTagName("ENABLE_MEDIA_PRELOAD")[0].childNodes[0].nodeValue == "1"} catch(err){enable_media_preload = false;}
try{enable_email_catching = xmlSetup.getElementsByTagName("ENABLE_EMAIL_CATCHING")[0].childNodes[0].nodeValue == "1"} catch(err){enable_email_catching = false;}
try{progressBar = xmlSetup.getElementsByTagName("HAS_PROGRESS_BAR")[0].childNodes[0].nodeValue == "1"} catch(err){progressBar = false;}
try{screen_calibrate = xmlSetup.getElementsByTagName("CALIBRATE_SCREEN")[0].childNodes[0].nodeValue;} catch(err){screen_calibrate = "na";}
try{screen_general = xmlSetup.getElementsByTagName("GENERAL_INSTRUCTIONS")[0].childNodes[0].nodeValue;} catch(err){screen_general = "na";}
try{screen_general_text = xmlSetup.getElementsByTagName("GENERAL_INSTRUCTIONS_TEXT")[0].childNodes[0].nodeValue;} catch(err){screen_general_text = "na";}
try{consent_form_enabled = xmlSetup.getElementsByTagName("CONSENT_FORM")[0].childNodes[0].nodeValue;} catch(err){consent_form_enabled = "off";}
try{screen_consent = xmlSetup.getElementsByTagName("CONSENT_FORM")[0].childNodes[0].nodeValue;} catch(err){screen_consent = "na";}
try{record_os = xmlSetup.getElementsByTagName("RECORD_OS")[0].childNodes[0].nodeValue;} catch(err){record_os = "na";}
try{record_audio_all = xmlSetup.getElementsByTagName("RECORD_AUDIO_ALL")[0].childNodes[0].nodeValue;} catch(err){record_audio_all = "na";}
try{record_framerate = xmlSetup.getElementsByTagName("RECORD_FRAMERATE")[0].childNodes[0].nodeValue;} catch(err){record_framerate = "na";}
try{record_browser = xmlSetup.getElementsByTagName("RECORD_BROWSER")[0].childNodes[0].nodeValue;} catch(err){record_browser = "na";}
try{record_screen_size = xmlSetup.getElementsByTagName("RECORD_SCREEN_SIZE")[0].childNodes[0].nodeValue;} catch(err){record_screen_size = "na";}
try{record_calibration = xmlSetup.getElementsByTagName("RECORD_CALIBRATION")[0].childNodes[0].nodeValue;} catch(err){record_calibration = "na";}
try{generate_code = xmlSetup.getElementsByTagName("GENERATE_CODE")[0].childNodes[0].nodeValue;} catch(err){generate_code = "na";}
try{display_score = xmlSetup.getElementsByTagName("DISPLAY_SCORE")[0].childNodes[0].nodeValue;} catch(err){display_score = "na";}
try{save_on_server = xmlSetup.getElementsByTagName("ON_SERVER")[0].childNodes[0].nodeValue;} catch(err){save_on_server = "na";}
try{save_on_computer = xmlSetup.getElementsByTagName("ON_COMPUTER")[0].childNodes[0].nodeValue;} catch(err){save_on_computer = "na";}
try{status = xmlSetup.getElementsByTagName("STATUS")[0].childNodes[0].nodeValue;} catch(err){status = "na";}
try{textSize_setup = xmlSetup.getElementsByTagName("TEXT_SIZE")[0].childNodes[0].nodeValue;} catch(err){textSize_setup = "na";}
try{textColor_setup = xmlSetup.getElementsByTagName("TEXT_COLOR")[0].childNodes[0].nodeValue;} catch(err){textColor_setup = "na";}
try{textBgColor_setup = xmlSetup.getElementsByTagName("TEXT_BG_COLOR")[0].childNodes[0].nodeValue;} catch(err){textBgColor_setup = "na";}
try{participant_feedback = xmlSetup.getElementsByTagName("PARTICIPANT_FEEDBACK")[0].childNodes[0].nodeValue;} catch(err){participant_feedback = "na";}
try{show_debrief = xmlSetup.getElementsByTagName("DEBRIEF_SHOW_RESULTS")[0].childNodes[0].nodeValue;} catch(err){show_debrief = 0;}
try{show_visuals = xmlSetup.getElementsByTagName("DEBRIEF_SHOW_VISUALS")[0].childNodes[0].nodeValue;} catch(err){show_visuals = 0;}
try{recaptcha = xmlSetup.getElementsByTagName("RECAPTCHA")[0].childNodes[0].nodeValue;} catch(err){recaptcha = 0;}

try{debrief_text = xmlSetup.getElementsByTagName("DEBRIEF_TEXT")[0].childNodes[0].nodeValue;} catch(err){debrief_text = "na";}
try{debrief_average_text = xmlSetup.getElementsByTagName("DEBRIEF_AVERAGE_TEXT")[0].childNodes[0].nodeValue;} catch(err){debrief_average_text = "na";}
try{debrief_is_random_code = xmlSetup.getElementsByTagName("DEBRIEF_IS_RANDOM_CODE")[0].childNodes[0].nodeValue;} catch(err){debrief_is_random_code = 0;}
try{debrief_code = xmlSetup.getElementsByTagName("DEBRIEF_CODE")[0].childNodes[0].nodeValue;} catch(err){debrief_code = "na";}
try{debrief_code_text = xmlSetup.getElementsByTagName("DEBRIEF_CODE_TEXT")[0].childNodes[0].nodeValue;} catch(err){debrief_code_text = "na";}
try{debrief_show_link = xmlSetup.getElementsByTagName("DEBRIEF_SHOW_LINK")[0].childNodes[0].nodeValue;} catch(err){debrief_show_link = 0;}
try{debrief_link_url = xmlSetup.getElementsByTagName("DEBRIEF_LINK_URL")[0].childNodes[0].nodeValue;} catch(err){debrief_link_url = "";}
try{debrief_auto_redirect = parseInt(xmlSetup.getElementsByTagName("DEBRIEF_AUTO_REDIRECT")[0].childNodes[0].nodeValue, 10);} catch(err){debrief_auto_redirect = 0;}
try{debrief_link_text = xmlSetup.getElementsByTagName("DEBRIEF_LINK_TEXT")[0].childNodes[0].nodeValue;} catch(err){debrief_link_text = "";}
try{debrief_link_textarea = xmlSetup.getElementsByTagName("DEBRIEF_LINK_TEXTAREA")[0].childNodes[0].nodeValue;} catch(err){debrief_link_textarea = "";}
try{consent_text1 = xmlSetup.getElementsByTagName("CONSENT_TEXT1")[0].childNodes[0].nodeValue;} catch(err){consent_text1 = "";}
try{consent_text2 = xmlSetup.getElementsByTagName("CONSENT_TEXT2")[0].childNodes[0].nodeValue;} catch(err){consent_text2 = "";}
try{consent_text3 = xmlSetup.getElementsByTagName("CONSENT_TEXT3")[0].childNodes[0].nodeValue;} catch(err){consent_text3 = "";}
try{consent_text4 = xmlSetup.getElementsByTagName("CONSENT_TEXT4")[0].childNodes[0].nodeValue;} catch(err){consent_text4 = "";}
try{consent_text5 = xmlSetup.getElementsByTagName("CONSENT_TEXT5")[0].childNodes[0].nodeValue;} catch(err){consent_text5 = "";}
try{consent_text6 = xmlSetup.getElementsByTagName("CONSENT_TEXT6")[0].childNodes[0].nodeValue;} catch(err){consent_text6 = "";}
try{consent_same_screen1 = xmlSetup.getElementsByTagName("CONSENT_SAME_SCREEN1")[0].childNodes[0].nodeValue;} catch(err){consent_same_screen1 = null;}
try{consent_same_screen2 = xmlSetup.getElementsByTagName("CONSENT_SAME_SCREEN2")[0].childNodes[0].nodeValue;} catch(err){consent_same_screen2 = null;}
try{consent_same_screen3 = xmlSetup.getElementsByTagName("CONSENT_SAME_SCREEN3")[0].childNodes[0].nodeValue;} catch(err){consent_same_screen3 = null;}
try{consent_same_screen4 = xmlSetup.getElementsByTagName("CONSENT_SAME_SCREEN4")[0].childNodes[0].nodeValue;} catch(err){consent_same_screen4 = null;}
try{consent_same_screen5 = xmlSetup.getElementsByTagName("CONSENT_SAME_SCREEN5")[0].childNodes[0].nodeValue;} catch(err){consent_same_screen5 = null;}
try{consent_reject_text = xmlSetup.getElementsByTagName("CONSENT_REJECT_TEXT")[0].childNodes[0].nodeValue;} catch(err){consent_reject_text = null;}
try{consent_image1 = xmlSetup.getElementsByTagName("CONSENT_IMAGE1")[0].childNodes[0].nodeValue;} catch(err){consent_image1 = null;}
try{consent_image2 = xmlSetup.getElementsByTagName("CONSENT_IMAGE2")[0].childNodes[0].nodeValue;} catch(err){consent_image2 = null;}
try{consent_image3 = xmlSetup.getElementsByTagName("CONSENT_IMAGE3")[0].childNodes[0].nodeValue;} catch(err){consent_image3 = null;}
try{consent_image4 = xmlSetup.getElementsByTagName("CONSENT_IMAGE4")[0].childNodes[0].nodeValue;} catch(err){consent_image4 = null;}
try{consent_image5 = xmlSetup.getElementsByTagName("CONSENT_IMAGE5")[0].childNodes[0].nodeValue;} catch(err){consent_image5 = null;}
try{consent_image6 = xmlSetup.getElementsByTagName("CONSENT_IMAGE6")[0].childNodes[0].nodeValue;} catch(err){consent_image6 = null;}
try{infosheet_text = xmlSetup.getElementsByTagName("INFOSHEET_TEXT")[0].childNodes[0].nodeValue;} catch(err){infosheet_text = null;}
try{infosheet_type = xmlSetup.getElementsByTagName("INFOSHEET_TYPE")[0].childNodes[0].nodeValue;} catch(err){infosheet_type = null;}
try{infosheet_filetype = xmlSetup.getElementsByTagName("INFOSHEET_FILETYPE")[0].childNodes[0].nodeValue;} catch(err){infosheet_filetype = null;}
try{infosheet_file = xmlSetup.getElementsByTagName("INFOSHEET_FILE")[0].childNodes[0].nodeValue;} catch(err){infosheet_file = null;}
try{participant_mandatory_fields = xmlSetup.getElementsByTagName("PARTICIPANT_MANDATORY_FIELDS")[0].childNodes[0].nodeValue;} catch(err){participant_mandatory_fields = true;}
try{screenout_show = xmlSetup.getElementsByTagName("SCREEN_OUT_SHOW")[0].childNodes[0].nodeValue === "1";} catch(err){screenout_show = false;}
try{screenout_text = xmlSetup.getElementsByTagName("SCREEN_OUT_TEXT")[0].childNodes[0].nodeValue;} catch(err){screenout_text = trans('screenout.text');}
try{screenout_auto_redirect = xmlSetup.getElementsByTagName("SCREEN_OUT_AUTO_REDIRECT")[0].childNodes[0].nodeValue === "1";} catch(err){screenout_auto_redirect = false;}
try{screenout_link_url = xmlSetup.getElementsByTagName("SCREEN_OUT_LINK_URL")[0].childNodes[0].nodeValue;} catch(err){screenout_link_url = null;}
try{screenout_link_url_text = xmlSetup.getElementsByTagName("SCREEN_OUT_LINK_TEXT")[0].childNodes[0].nodeValue;} catch(err){screenout_link_url_text = "";}

//end setup

/*ask for password to continue*/
requestPassword(window.pwdProtected, window.pwd);

console.log('language:'+language);

    //get browser info
    browser=get_browser_info();

if (consent_form_enabled == "off") {
  screen_infosheet = "off";
}

if (screen_consent != "na" && screen_consent != "off" && screen_consent != "0") {
  screen_consent = "on";
}

if (browser.name == "IE ")
{
  alert(textScreens['warnings'][language]['ie']);
  hideAll();
} else {

  //WARNING: this might break participants from Minds or other subject pools who are running in private mode and the experiment has one response per IP
  if (!detectLocalStorageAvailability()){
    alert(textScreens['warnings'][language]['localstorage']);
    hideAll();
  } else {
    if (recaptcha == 1 && mindId == '' && !window.inPreviewMode) {
      var verifyRecaptchaResponse = function(response) {
        console.log(response);
        window.antibot_token = response;
        document.getElementById('displayScreen').style.display = "block";
        document.getElementById('preloadOverlay').style.display = "block";
        document.getElementById('recaptcha_holder').style.display = "none";
        startDisplayScreen();
      };
      var onRecaptchaLoadCallback = function() {
        grecaptcha.render('recaptcha_holder', {
          'sitekey' : recaptcha_site_key,
          'callback' : verifyRecaptchaResponse,
        });
      }
    } else {
      startDisplayScreen();
    }
  }
}

function startDisplayScreen() {
  if (window.withoutRun) {
    console.log('no run set');
    return;
  }

  // we keep the async behavior to be sure that we don't break anything
  // if we remove the setTimeout because we define some variables in other files that are used in onDownloadsDone
  // for example we get error: 1_first.js:823 Uncaught ReferenceError: listBackgroundAudioOptions is not defined
  setTimeout(onDownloadsDone, 1);
}

function detectLocalStorageAvailability() {
  var isLocalStorageAvailable = true;
  try {
    if (typeof localStorage == 'undefined' || localStorage == null) {
      isLocalStorageAvailable = false
    } else {
      localStorage.setItem('check', 'available');
      localStorage.removeItem('check');
    }
  } catch(e) {
    isLocalStorageAvailable = false;
  }
  return isLocalStorageAvailable;
}

function onDownloadsDone() {






  window.staircases = trialData.staircases;
  window.trialStaircases = trialData.trialStaircases;

  window.listArrays = trialData.listArrays;
  window.definedColumns = trialData.definedColumns;
  window.listUnusedArrays = trialData.listUnusedArrays;
  window.csvNewColumns = trialData.csvNewColumns;
  window.noTrials = Number(listArrays[0].length);

  window.onePercNoTrials = Math.round(noTrials/100);
  window.tenPercNoTrials = Math.round(noTrials/10);
  window.noTrialsGroup = noTrials;/*will change if subjectGroups > 1*/

  allColumnsCsvCase = allColumns.slice(0);
  csvValidColumns = trialData.csvValidColumns;

  console.log('allcolumns2:'+allColumns);

  /*pass all values from new columns in stimfile to JS arrays*/
  window.saveUnusedArrays = new Array(csvNewColumns.length);
  for (window.iCol = 0; iCol < csvNewColumns.length; iCol++)
  {
    saveUnusedArrays[iCol] = new Array(csvNewColumns[iCol]);
  }


  if (window.skipPreload) {
    setupResponseBoxesButtons();
    onPrepareDone('imagesPreload');
    onPrepareDone('mediaPreload');
  }

  /*get parameters for the experiment*/
  for (var i = 0; i < noTrials; i++)
  {
    //cip-seq remove
    // if (isNaN(listArrays[getAllCollumnsIndexOf('ITI')][i])){listArrays[getAllCollumnsIndexOf('ITI')][i]=0;}

    // convert stimFormat to lower case
    listArrays[getAllCollumnsIndexOf('stimFormat')][i] = listArrays[getAllCollumnsIndexOf('stimFormat')][i].toLowerCase();

    // remove potential file extensions from stim columns, if found, to avoid conflict with stimFormat
    // only for trials with images, sounds, videos
    window.stimFormatThisTrial = listArrays[getAllCollumnsIndexOf('stimFormat')][i];
    if (imageAudioVideoFormats.indexOf(stimFormatThisTrial) > -1) {
      for (window.iImageColumns = 0; iImageColumns < imageColumns.length; iImageColumns++) {
        if (listArrays[getAllCollumnsIndexOf(imageColumns[iImageColumns])][i]!='na'){
          window.stimFilename = listArrays[getAllCollumnsIndexOf(imageColumns[iImageColumns])][i];
          window.stimFilenameLong = stimFilename + stimFormatThisTrial;
          window.tempArray = stimFilenameLong.split(".");
          if (tempArray.length>2){
            if (tempArray[tempArray.length-1] == (tempArray[tempArray.length-2].toLowerCase())){
              stimFilename = stimFilename.split('.'+tempArray[tempArray.length-2]).shift();
            }
          }
        }
      }
    }

    // pre-split stimList column values for each trial
    window.stimListValues[i] = "na";
    const stimListContent = window.columnForTrial('stimList', i);
    if(stimListContent !== "na") {
      window.stimListValues[i] = stimListContent.split(';');
    } else if(window.columnForTrial('stim', i) !== "na") {
      window.stimListValues[i] = window.columnForTrial('stim', i).split(';');
    }

    // determine trial type
    listStimType[i] = computeTrialType(i);

    listNoStim[i] = 0;

    if (listArrays[getAllCollumnsIndexOf('stim1')][i]=="na") {
        listNoStim[i]=0;
    }

    for(var stimIndex = 1; stimIndex <= window.stimFieldsMax; stimIndex++){
      if (listArrays[getAllCollumnsIndexOf('stim' + stimIndex)][i]!="na"){
        listNoStim[i] = stimIndex;
      }
    }

    if (window.stimListValues[i] && window.stimListValues[i] !== "na" && window.stimListValues[i].length > listNoStim[i]){
      listNoStim[i] = window.stimListValues[i].length;
    }

    if (window.columnForTrial('stim_actual', i) != "na") {
        const stimListStimuli = getStimsFromListsForTrial(i)
        listNoStim[i] = stimListStimuli.length;
    }

    console.log('listNoStim', i, listNoStim[i]);

    //setup and compute screens for current trial
    window.isiValue = listArrays[getAllCollumnsIndexOf('ISI')][i];
    window.presTimeValue = listArrays[getAllCollumnsIndexOf('presTime')][i];
    window.stimuliNumber = listNoStim[i];
    window.withTarget = listArrays[getAllCollumnsIndexOf('target')][i] != "na";
    window.presTime2 = columnForTrial('presTime2', i);
    if (presTime2 == 'na') {
      presTime2 = columnForTrial('presTimeS2', i);
    }


    if (withTarget) {
      stimuliNumber++;
    }

    window.screensTiming = initScreensTimingData(isiValue, presTimeValue, stimuliNumber, withTarget, presTime2);
    listTrialScreensTimings[i] = screensTiming;
    console.log('screens for ', i ,': ',  screensTiming);


    //parse text values
    window.trialTextValue = listArrays[getAllCollumnsIndexOf('trialText')][i];
    window.trialTextOptionsValue = listArrays[getAllCollumnsIndexOf('trialTextOptions')][i];
    window.trialNumberOfScreens = screensTiming.length;
    window.trialTexts = initTrialText(trialTextValue, trialTextOptionsValue, trialNumberOfScreens);
    listTrialTexts[i] = trialTexts;

    //parse background values
    window.listBackgroundOptions[i] = precomputeBackgroundOptions(i);

    // parse fixation
    window.fixationValue = columnForTrial('fixation', i);
    window.fixationStimValue = columnForTrial('fixationStim', i);
    listTrialFixation[i] = initFixation(fixationValue, fixationStimValue);

    // parse responseWindow
    window.responseWindowValue = columnForTrial('responseWindow', i);
    window.waitStimEndValue = columnForTrial('waitStimEnd', i);
    listTrialResponseWindow[i] = initResponseWindow(responseWindowValue, waitStimEndValue);

    // parse audio column
    listBackgroundAudioOptions[i] = parseAudioColumn(columnForTrial('audio', i));


    window.responseTypeValue = columnForTrial('responseType', i);
    window.responseOptionsValue = columnForTrial('responseOptions', i);

    listTrialResponseOptions[i] = initResponseOptions(responseTypeValue, responseOptionsValue);
    listTrialBoxOptions[i] = parseResponseAttribtes(responseOptionsValue);
    listTrialCssOptions[i] = parseStimCssOptions(i);
    listTrialCursorOptions[i] = getCursorOptions(columnForTrial('cursor', i));
    listTrialColorOptions[i] = getColorsColumnOptions(i);

    listTrialResponseRowsLabels[i] = initResponseRowsLabels(columnForTrial('responseRows', i));

    listTrialScripts[i] = initializeUserScripts(i);
    listTrialScores[i] = window.getScoreObject(i);

    listNoStimS2[i]=0;/*screen 2*/

  // console.log('isi', isNaN(listArrays[getAllCollumnsIndexOf('ISI')][i]), listArrays[getAllCollumnsIndexOf('ISI')][i], i );

    //cip: required for words atm
    if (!isNaN(listArrays[getAllCollumnsIndexOf('ISI')][i]))/*for sequential presentation*/
    {
      /*WITHOUT A TARGET AND ONLY FOR IMAGES OR WORDS*/

      if (listArrays[getAllCollumnsIndexOf('target')][i]=="na" && listNoStim[i]>1 && (listStimType[i]==1 || listStimType[i]==2))
      {

        listNoStimS2[i]=listNoStim[i]-1;/*screen 2*/
        listNoStim[i]=1;/*screen 1*/
      }
      /*WITH TARGET*/
      else
      {
        listNoStimS2[i]=listNoStim[i];/*screen 2*/
      }
    }

    //determine number of form questions
    iFormQ = 1;
    while (listArrays[getAllCollumnsIndexOf('formQ'+iFormQ)][i]!="na" && iFormQ < formColumnsQ.length+1)
    {
        iFormQ++;
    }
    listNoFormQ[i] = iFormQ - 1;

    if (listArrays[getAllCollumnsIndexOf('button1')][i]=="na"){listNoButtons[i]=0;}
    for ( var bi = 0; bi < buttonColumns.length; bi++ ) {
      if (listArrays[getAllCollumnsIndexOf('button' + (bi + 1))][i] != "na") {
        listNoButtons[i] = bi + 1;
      }
    }

  //determine response options - STILL CHECK THAT IT WORKS!!! -- need to delete above buttons when implemented!!
    // responseOptionsArray = new Array();
    // responseOptionsArray[i] = {};
    // responseOptionsForm = listArrays[getAllCollumnsIndexOf('responseOptions')][i].split(";");
    // responseOptionsArray[i]["type"]=responseOptionsForm.shift();
    // responseOptionsArray[i]["labels"]=responseOptionsForm;
    // console.log(responseOptionsArray[i]["type"]);

    // if (responseOptionsArray[i]["type"]!="na")
    // {
    //   listNoButtons[i]=responseOptionsArray[i]["labels"].length;
    // }
    // else //this is for back compatibility
    // {
    //   if (listArrays[getAllCollumnsIndexOf('button1')][i]=="na"){listNoButtons[i]=0;}
    //   if (listArrays[getAllCollumnsIndexOf('button1')][i]!="na"){listNoButtons[i]=1;}
    //   if (listArrays[getAllCollumnsIndexOf('button2')][i]!="na"){listNoButtons[i]=2;}
    //   if (listArrays[getAllCollumnsIndexOf('button3')][i]!="na"){listNoButtons[i]=3;}
    //   if (listArrays[getAllCollumnsIndexOf('button4')][i]!="na"){listNoButtons[i]=4;}
    //   if (listArrays[getAllCollumnsIndexOf('button5')][i]!="na"){listNoButtons[i]=5;}
    //   if (listArrays[getAllCollumnsIndexOf('button6')][i]!="na"){listNoButtons[i]=6;}
    // }


  /*determine if trials need image/word clicks or not*/
    window.hasMultipleStimuli = hasMultipleStimuliOnAnyScreen(listTrialScreensTimings[i]);

    if ((listArrays[getAllCollumnsIndexOf('type')][i]=="test" || listArrays[getAllCollumnsIndexOf('type')][i]=="practice") && listArrays[getAllCollumnsIndexOf('keyboard')][i]=="na" && listArrays[getAllCollumnsIndexOf('button1')][i]=="na")
    {
      enableClicks[i] = 1;
    }
    else
    {
      enableClicks[i] = 0;
    }


    // if (i!=noTrials-1 && listArrays[getAllCollumnsIndexOf('type')][i]=="test" && listArrays[getAllCollumnsIndexOf('type')][i+1]!="test"){nTestBlocks = nTestBlocks + 1;}/*count number of blocks by when trials switch from test to something else*/
    // if (i==noTrials-1 && listArrays[getAllCollumnsIndexOf('type')][i]=="test"){nTestBlocks = nTestBlocks + 1;}/*for when the last trial is test*/

    if (i == 0) {listBlockNo[i]=0;}/*assign numbers to counter blocks*/
    else
      {
        listBlockNo[i]=listBlockNo[i-1]+(listArrays[getAllCollumnsIndexOf('type')][i]!=listArrays[getAllCollumnsIndexOf('type')][i-1]);/*adds one if blocks different, 0 otherwise*/
      }

    window.trialsLogicFn[i] = new Function('response', 'responseCode',  'correct', 'RT', trialData.trialsLogic[i]);
    window.keyTrialsLogicFn[i] = new Function('response', 'responseCode', 'RT', trialData.keyTrialsLogic[i]);

    //We have a timer:start defined in the then column which means timer based breaks need to wait for that trial first
    if(trialData.trialsLogic[i].indexOf('startBreakTimestamp') >= 0){
      window.breakTimerWaitForStartCall = true;
      window.timerStartThisTrial = false;
    }

    listTrialFrames[i] = precomputeIsFramesTrial(i);

    listStimSizeFunctions[i] = precomputeStimSize(i);

    listTrialBreak[i] = precomputeBreakTrial(i);

    listTrialLongWords[i] = window.initLongWords(i);

    precomputeTimerValue(i);
  }


  if (!window.skipPreload) {
    console.log('start preloading');
    /*preload all images needed for experiment;*/
    $(function() {
        console.log('dom ready')
        setupResponseBoxesButtons();
        preloadImages(Number(listArrays[0].length));
        preloadMedia(Number(listArrays[0].length));
        QueryLoader.init();
    });
  }

  window.trialLabels = window.trialData.trialLabels;

  window.nTrialsBlock = new Array(100+1).join('0').split('').map(parseFloat);/*create array with 100 zeros to store number of trials in each block (i.e. max 100 blocks)*/
  window.nTrialsBlockGroup = new Array(100+1).join('0').split('').map(parseFloat);/*create array with 100 zeros to store number of trials in each block (i.e. max 100 blocks)*/


  /*get total number of trials in a block (needed to display later if required)*/
  for(var i = 0; i < listBlockNo.length; ++i)
  {
    for(window.j = 0; j < 100; j++)
      {
        if(listBlockNo[i] == j)
          {
            nTrialsBlock[j]++;
          }
      }
  }


  //////////////////// NEW RANDOMISATION /////////////////////
  window.trialList = new Array(noTrials);
  window.randomList = [];
  window.randomBlockList = [];

  //create initial trial order
  for(var i=0;i<noTrials;i++){window.trialList[i]=i;}

  if(window.trialData.rules){
    window.applyRules();
  }

  for(var i = 0; i < trialList.length; i++){
    window.randomList[i] = window.columnForTrial('random', trialList[i]);
    window.randomBlockList[i] = window.columnForTrial('randomBlock', trialList[i]);
  }

  //randomise within blocks
  if(!columnIsDefined('randomPick') || isEmptyColumn('randomPick')){
    if (!(allTheSame(randomList) && randomList[0]=='na'))
    {
      trialList = randomizeWithinBlocks(trialList,randomList,randomBlockList, listTrialTimerLabels);
    }
    console.log('trialList:'+trialList);

    //randomise between blocks
    if (!(allTheSame(randomBlockList) && randomBlockList[0]=='na'))
    {
      trialList = randomizeBlocks(trialList,randomBlockList);
    }
    console.log('trialList:'+trialList);
  }

  //because I use stimOrder later
  stimOrder = trialList;
  console.log('stimOrder', stimOrder);

  window.initSubjectGroupAllocation();

  window.filterBreaksBySubjectGroup();

  // make some shorter lists based on stimOrder
  listType = [];
  listCounterTrial = [];
  listCounterPart = [];
  listRandomPick = [];
  listRandom = [];
  listRandomGroup = [];
  listRandomBlock = [];

    const listTrialTimerLabelsAfterRandom = [];
    for(var i = 0; i < stimOrder.length; ++i)
    {
      listType[i] = listArrays[getAllCollumnsIndexOf('type')][stimOrder[i]];
      listCounterTrial[i] = listArrays[getAllCollumnsIndexOf('counterTrial')][stimOrder[i]];
      listCounterPart[i] = listArrays[getAllCollumnsIndexOf('counterPart')][stimOrder[i]];
      listRandomPick[i] = listArrays[getAllCollumnsIndexOf('randomPick')][stimOrder[i]];
      listRandomGroup[i] = listArrays[getAllCollumnsIndexOf('trialGroup')][stimOrder[i]];
      listRandom[i] = listArrays[getAllCollumnsIndexOf('random')][stimOrder[i]];
      listRandomBlock[i] = listArrays[getAllCollumnsIndexOf('randomBlock')][stimOrder[i]];
      listTrialTimerLabelsAfterRandom[i] = listTrialTimerLabels[stimOrder[i]];
    }
    listTrialTimerLabels = listTrialTimerLabelsAfterRandom;

  //randomly pick a subset of trials from defined groups
  if (!allTheSameAndNA(listRandomPick))
  {
    if(!columnIsDefined('trialGroup')){
      stimOrder = pickRandomTrials(stimOrder, listType, listRandom, listRandomBlock, listRandomPick);

      // random blocks
      if (!(allTheSame(randomBlockList) && randomBlockList[0]=='na')) {
        stimOrder = randomizePickedTrialsBlocks(stimOrder);
      }

      var newListRandom = [], newListBlocks = [];

      for(var index in stimOrder){
        newListRandom[index] = columnForTrial('random',stimOrder[index]);
        newListBlocks[index] = columnForTrial('randomBlock', stimOrder[index]);
      }

      stimOrder = randomizeWithinBlocks(stimOrder, newListRandom, newListBlocks, listTrialTimerLabels);
    }
    else{
      stimOrder = pickRandomTrialsWithRandomGroup(stimOrder, listRandomPick, listRandomGroup, listRandom, listRandomBlock, listType, listTrialTimerLabels);
    }
    noTrialsGroup = stimOrder.length;
  }
  //compute number of trials-screens for progress bar
  excludeFromCount = 0;
  includeInCount = 0;
  for (var i = 0; i < stimOrder.length; i++) {
    if (i!=stimOrder.length-1 && columnForTrial('type', stimOrder[i]) == 'form' && columnForTrial('pageBreak', stimOrder[i]) == 'na') {
      excludeFromCount++;
    }
  }
  for (var i = 1; i < stimOrder.length; i++) {
    if (columnForTrial('type', stimOrder[i-1]) == 'form' && columnForTrial('pageBreak', stimOrder[i-1]) == 'na' && columnForTrial('type', stimOrder[i]) != 'form') {
      includeInCount++;
    }
  }

  //counterTrial info
  stimOrderCounterTrial = [];
  if (!allTheSameAndNA(listArrays[getAllCollumnsIndexOf('counterTrial')]))
  {
    stimOrderCounterTrial = findCounterTrial(stimOrder,listCounterTrial,listType);
  }


  //counterBlock info
  stimOrderCounterPart = [];
  if (!allTheSameAndNA(listCounterPart))
  {
    stimOrderCounterPart = findCounterPart(stimOrder,listCounterPart,listType);
  }

  precomputeTimerSkips(stimOrder);

    //get browser info
    browser=get_browser_info();

  /*check for Firefox*/
  if (browser.name == "Firefox" &&  !allTheSameAndNA(listArrays[getAllCollumnsIndexOf('keyboard')]))
    {
      //alert(textScreens['warnings'][language]['firefox']);
    }

  // warning for tablets and mobiles
  // if(typeof window.orientation !== 'undefined')
  //   {
  //     alert(textScreens['warnings'][language]['mobile']);
  //   }

    if(record_browser == "on")
      {
        saveInfo.push(browser.name);
        saveInfo.push(browser.version);
        saveInfoColumns.push('browser');
        saveInfoColumns.push('version');
        // browserInfo.push(browser.name);
        // browserInfo.push(browser.version);
        // browserInfo.push(navigator.vendor);//does the vendor refer to browser or OS??
      }
    if(record_screen_size == "on")
      {
        saveInfo.push(screen.width);
        saveInfo.push(screen.height);
        saveInfoColumns.push('screenWidth');
        saveInfoColumns.push('screenHeight');
        // browserInfo.push(screen.width);
        // browserInfo.push(screen.height);
      }
    if(record_os == "on")
      {
        window.OSName="unknown OS";
        if (navigator.appVersion.indexOf("Win")!=-1) {OSName="Windows";}
        if (navigator.appVersion.indexOf("Mac")!=-1) {OSName="MacOS";}
        if (navigator.appVersion.indexOf("X11")!=-1) {OSName="UNIX";}
        if (navigator.appVersion.indexOf("Linux")!=-1) {OSName="Linux";}
        saveInfo.push(OSName);
        saveInfo.push(navigator.language);
        saveInfoColumns.push('OS');
        saveInfoColumns.push('OS_lang');
        // browserInfo.push(OSName);
        // browserInfo.push(navigator.language);
      }

      // browserInfo[0] = navigator.appName;
      // browserInfo[1] = screen.width;
      // browserInfo[2] = screen.height;
      // browserInfo[3] = screen.availWidth;
      // browserInfo[4] = screen.availHeight;
      // browserInfo[5] = navigator.platform;
      // browserInfo[6] = navigator.language;
      // browserInfo[7] = navigator.vendor;
      // browserInfo[8] = adjuster;


    var newdate = new Date()
    saveInfo.push(getFormattedDate(newdate));
    saveInfo.push(getFormattedDate(new Date(newdate.getTime() - (newdate.getTimezoneOffset() * 60000))));
    saveInfo.push(getFormattedDate(new Date(window.trialFileTimestamp)));
    saveInfoColumns.push('GMT_timestamp');
    saveInfoColumns.push('local_timestamp');
    saveInfoColumns.push('trial_file_version');

    //minds id
    if (window.mindId) {
      saveInfoColumns.push('mindsCode');
      saveInfo.push(window.mindId);
    }

    if (window.batchId) {
      saveInfoColumns.push('batchID');
      saveInfo.push(window.batchId);
    }

    if (window.urlParamsToSave) {
      for (const [key, value] of Object.entries(window.urlParamsToSave)) {
        saveInfoColumns.push(key);
        saveInfo.push(value);
      }
    }

    // save access link in results
    saveInfoColumns.push('link');
    saveInfo.push(location.href);

    //all setup done
    console.log('initReady');
    onPrepareDone('setup');

    window.logExperimentEvent(window.consortEvents.STARTED);
    setTimeout(timeoutExperiemnt, experimentTimeoutLimit);

    // maybe this can be removed and call directly in show blade
    $(onReadyInit);
};

function getFormattedDate(date) {
  return date.toISOString().replace('T', '_').split('.')[0]
}

function columnForTrial(columnName, trialIndex) {
  return listArrays[getAllCollumnsIndexOf(columnName)][trialIndex];
}

// get value from custom columns
function columnCustomForTrial(columnName, trialIndex) {
    return listUnusedArrays[getCustomCollumnsIndexOf(columnName)][trialIndex];
  }

function columnIsDefined(columnName){
  return definedColumns[allColumns.indexOf(columnName)] === 1;
}

function columnArray(columnName) {
  return listArrays[getAllCollumnsIndexOf(columnName)];
}

function computeProgressBar() {
  return Math.round(100*window.trial/window.stimOrder.length);
}

// aux functions
//source https://stackoverflow.com/questions/36390853/how-to-remove-specific-character-surrounding-a-string#answer-43301891
function trimChars(str, chars) {
  var l = 0;
  var r = str.length-1;
  while(chars.indexOf(str[l]) >= 0 && l < r) l++;
  while(chars.indexOf(str[r]) >= 0 && r >= l) r--;
  return str.substring(l, r+1);
}

function testableOnEvent(eventName, handler) {
  $(document).on( eventName, handler);
}

function testableTriggerEvent(eventName, eventData) {
  var data = eventData != undefined ?  [eventData] : null;
  $(document).trigger( eventName, data);
}

//indexOf with memoization
function getAllCollumnsIndexOf(columnName) {
  if (getAllCollumnsIndexOf.cache === void 0) {
    getAllCollumnsIndexOf.cache = {};
  }

  if (getAllCollumnsIndexOf.cache[columnName] === void 0) {
      getAllCollumnsIndexOf.cache[columnName] = window.allColumns.indexOf(columnName);
  }

  return getAllCollumnsIndexOf.cache[columnName];
}

// indexOf with memoization for custom columns
function getCustomCollumnsIndexOf(columnName) {
    if (getCustomCollumnsIndexOf.cache === void 0) {
        getCustomCollumnsIndexOf.cache = {};
    }

    if (getCustomCollumnsIndexOf.cache[columnName] === void 0) {
        getCustomCollumnsIndexOf.cache[columnName] = window.csvNewColumns.indexOf(columnName);
    }

    return getCustomCollumnsIndexOf.cache[columnName];
}


//indexOf with memoization
function getImageFormatsIndexOf(imageFormat) {
  if (getImageFormatsIndexOf.cache === void 0) {
    getImageFormatsIndexOf.cache = {};
  }

  if (getImageFormatsIndexOf.cache[imageFormat] === void 0) {
      getImageFormatsIndexOf.cache[imageFormat] = window.imageFormats.indexOf(imageFormat);
  }

  return getImageFormatsIndexOf.cache[imageFormat];
}


// from show blade

function onReadyInit() {
  window.formArray = new Array();

  setDisplayVariables(adjuster);/*adjuster=1 originally*/

  window.initial = [];
  window.disableInitialSortRecording = 0;

  $(function() {
    if (!disableInitialSortRecording){
      $("#sortImg").sortable({}).disableSelection();
      $('.ui-state-default').each(function(index, anchor) {
        window.initial.push(anchor.innerHTML);
      });
    }

    window.disableInitialSortRecording = 1;

  });

  /*initialize keyboard listener*/
  //window.listener = new window.keypress.Listener();
  window.keyReleased = 1;
  document.addEventListener('keydown', check);
  document.addEventListener('keyup', releaseKey);

  window.delay = 1;
  //setTimeout("loadplayer();", delay * 1000);

  $(loadplayer);
}

function resetSort() {
    $('.ui-state-default').each(function(index, anchor) {
        anchor.innerHTML = window.initial[index];
    });

};

function loadplayer() {
    $("ul#sortImg").unbind('mousedown');
    initClickMarkers();
}

function loadplayerfortrials() {
    $('.i-checks').iCheck({
    checkboxClass: 'icheckbox_square-green',
    radioClass: 'iradio_square-green',
    });

    const sortingElements = sortable('.sortable', {
      placeholderClass: 'ui-sortable-placeholder ui-state-default'
    });

    sortingElements.forEach(function attachSortEnd(el) {
      el.addEventListener('sortstop', function(e) {
        onSortEnd(this);
      });
    });

    function onSortEnd(ul) {
      var articleOrder="";
      var cElement = "";
      $(ul).children("li").each(function onSortEndHandler(i) {
          cElement = $(this).attr('data-rank-element');
          if (articleOrder=='')
              articleOrder = $(this).attr('data-rank-id');
          else
              articleOrder += ";"+$(this).attr('data-rank-id');
      });
      $("#"+cElement).val(articleOrder);
    }

    $('input[type=checkbox],input[type=radio]').on('ifChecked', function(event) {
        var other = $(this).attr('data-other');
        var element = $(this).attr('data-element');
        if(other && other=="yes"){
             $("#"+element).show();
        }
    });

    $('input[type=checkbox],input[type=radio]').on('ifUnchecked', function(event) {
        var other = $(this).attr('data-other');
        var element = $(this).attr('data-element');
        if(other && other=="yes"){
            $("#"+element).hide();
        }
    });

}


function updateInputs (data) {
    if(data.from_value){
        $(data.input).val(data.from_value);
    }else{
        $(data.input).val(data.from);
    }
}

function isEmptyColumn(columnName) {
  var colValues = listArrays[getAllCollumnsIndexOf(columnName)];
  return colValues[0] == 'na' && allTheSame(colValues);
}


// end.2
// will return value at ['end'][lang]['2']
function trans(path, lang) {
  const searchLanguage = lang || window.language;
  const pathArr = path.split('.');
  pathArr.splice(1, 0, searchLanguage);
  console.log(pathArr);
  const text =  getValueAtPath(pathArr, window.textScreens);

  const defaultLanguage = 'english';
  // try to get for English as fallback
  if (!text && searchLanguage !== defaultLanguage) {
    return trans(path, defaultLanguage);
  }

  if (text === "" || text) {
    return  text;
  }

  // default to the incoming key if no translation was found
  return path;

  // https://medium.com/javascript-inside/safely-accessing-deeply-nested-values-in-javascript-99bf72a0855a
  // p is array
  function getValueAtPath(p, o) {
    return p.reduce(function(xs, x) { 
      return (xs && typeof xs[x] !== 'undefined') ? xs[x] : null
    }, o)
  }
}

